import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Warranty',
  name: 'warrantyCommonBlock',
  type: 'document',
  fields: [
    defineField({
      title: 'Warranty Block',
      name: 'warrantyBlock',
      type: 'warranty',
      description: 'This warranty block will be displayed on all wheel pages that reference it.',
    }),
  ],
  preview: {
    select: {
      title: 'warrantyBlock.title',
    },
    prepare({ title }) {
      return {
        title: title || 'Warranty',
        subtitle: 'Warranty Common Block',
      }
    },
  },
})
